<script>
  import { afterUpdate, onMount } from "svelte";
  import { promos } from "$lib/models/promos";

  /**@type {HTMLDialogElement}*/
  let modal;
  // @ts-ignore
  const bodyScroll = {
    prevent() {
      // @ts-ignore
      document.querySelector("body").style.overflow = "hidden";
    },
    allow() {
      // @ts-ignore
      document.querySelector("body").style.overflow = null;
    },
  };

  AbortSignal.timeout ??= function timeout(ms) {
    const ctrl = new AbortController();
    setTimeout(() => ctrl.abort(), ms);
    return ctrl.signal;
  };

  /**@type {boolean}*/
  let isOpenSales = false;
  /**@param {boolean}action
   * @param {string}name
   */
  const openSales = (action, name) => (isOpenSales = action);
  /**@param {boolean}action*/
  const openDialog = (action) => {
    isOpenSales = action;
    modal.showModal();
  };
  $: {
    isOpenSales;
    afterUpdate(() => {
      if (isOpenSales) {
        bodyScroll.prevent();
      } else {
        bodyScroll.allow();
      }
    });
  }

  /**@type {string}*/
  let component;

  afterUpdate(() => {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        isOpenSales = false;
      }
    });
  });
  let scrolling = 0;
  let gridScroll = 85;
  let opacity = 1;
  let isTop = false;
  /**@type {HTMLElement}*/
  let scrollElement;
  function scrollEvent() {
    if (scrollElement.scrollTop >= 50) {
      isTop = true;
      opacity = 0;
      gridScroll = 150;
      scrolling = 100;
    } else {
      scrolling = scrollElement.scrollTop * 2;
      gridScroll = 85 + scrollElement.scrollTop * 3;
      opacity = 1;
      isTop = false;
    }
  }

  /**@param {*}e*/
  const closeByBackdrop = (e) => {
    let rect = e.target.getBoundingClientRect();
    if (
      rect.left > e.clientX ||
      rect.right < e.clientX ||
      rect.top > e.clientY ||
      rect.bottom < e.clientY
    ) {
      modal.close();
      isOpenSales = false;
    }
  };

  /**@type {Date}*/
  let dayOfPublish;
  /**@type {Date}*/
  let today;
  /**@type {any}*/
  let validPromos = [];
  onMount(() => {
    today = new Date(Date.now());
    let utcNowDate = today.getUTCDate();
    let setUtcDateNow = today.setUTCDate(utcNowDate);

    promos.map((promo) => {
      let initDate = new Date(
        Date.UTC(promo?.publish_date[0], promo?.publish_date[1], promo?.publish_date[2])
      );
      let utcPromoDate = initDate.getUTCDate();
      let setUTCpromoInitDate = initDate.setUTCDate(utcPromoDate);
      let endDate = new Date(Date.UTC(promo?.end_date[0], promo?.end_date[1], promo?.end_date[2]));
      let utcPromoEndDate = endDate.getUTCDate();
      let setUTCpromoEndDate = endDate.setUTCDate(utcPromoEndDate);
      if (setUTCpromoInitDate <= setUtcDateNow && setUTCpromoEndDate >= setUtcDateNow) {
        validPromos.push(promo);
      }
    });
  });
</script>

<button
  class="exclusive-offers"
  class:active={isOpenSales}
  on:click={() => openDialog(!isOpenSales)}
  aria-labelledby="exclusive"
>
  {#if isOpenSales}
    <img src="/images/global/Close_white.svg" alt="close sale page" />
  {:else}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.681"
      height="28.059"
      viewBox="0 0 26.681 28.059"
    >
      <path
        id="featured_seasonal_and_gifts_24dp_FILL0_wght300_GRAD0_opsz24"
        d="M7.023-17.235V-29.981H6.888A2.057,2.057,0,0,1,5.377-30.6a2.057,2.057,0,0,1-.622-1.511v-3.052a2.057,2.057,0,0,1,.622-1.511A2.057,2.057,0,0,1,6.888-37.3h5.128a1.846,1.846,0,0,1-.4-.773,3.726,3.726,0,0,1-.107-.9,3.646,3.646,0,0,1,1.1-2.678,3.646,3.646,0,0,1,2.678-1.1,3.344,3.344,0,0,1,1.5.339,4.363,4.363,0,0,1,1.231.906,4.012,4.012,0,0,1,1.232-.917,3.431,3.431,0,0,1,1.5-.328,3.646,3.646,0,0,1,2.678,1.1,3.646,3.646,0,0,1,1.1,2.678,3.29,3.29,0,0,1-.118.889,2.343,2.343,0,0,1-.393.786H29.3a2.057,2.057,0,0,1,1.511.622,2.057,2.057,0,0,1,.622,1.511v3.052a2.057,2.057,0,0,1-.622,1.511,2.057,2.057,0,0,1-1.511.622h-.135v12.747a2.445,2.445,0,0,1-.746,1.793,2.444,2.444,0,0,1-1.793.746H9.561a2.444,2.444,0,0,1-1.793-.746A2.445,2.445,0,0,1,7.023-17.235ZM20.742-40.648a1.62,1.62,0,0,0-1.193.481,1.62,1.62,0,0,0-.481,1.193,1.62,1.62,0,0,0,.481,1.193,1.619,1.619,0,0,0,1.193.482,1.621,1.621,0,0,0,1.193-.482,1.62,1.62,0,0,0,.481-1.193,1.62,1.62,0,0,0-.481-1.193A1.621,1.621,0,0,0,20.742-40.648Zm-7.129,1.674a1.62,1.62,0,0,0,.481,1.193,1.619,1.619,0,0,0,1.193.482,1.619,1.619,0,0,0,1.193-.482,1.62,1.62,0,0,0,.481-1.193,1.62,1.62,0,0,0-.481-1.193,1.62,1.62,0,0,0-1.193-.481,1.62,1.62,0,0,0-1.193.481A1.62,1.62,0,0,0,13.612-38.974ZM6.861-35.193v3.106H17.042v-3.106ZM17.042-16.8V-29.981H9.129v12.747a.42.42,0,0,0,.122.311.42.42,0,0,0,.31.121Zm2.106,0h7.481a.42.42,0,0,0,.31-.121.42.42,0,0,0,.122-.311V-29.981H19.148ZM29.33-32.087v-3.106H19.148v3.106Z"
        transform="translate(-4.755 42.755)"
        fill="#fff"
      />
    </svg>
    <p>EXCLUSIVE OFFERS</p>
  {/if}
</button>

<span class="label" id="flame">See available offers at gelish.com</span>
<span class="label" id="exclusive">See available offers at gelish.com</span>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
  class="sales"
  class:open={isOpenSales}
  bind:this={modal}
  on:click={(e) => closeByBackdrop(e)}
>
  {#if isOpenSales}
    <div
      class="top-after"
      class:bgBlack={component == "exclusive"}
      style={isTop ? "z-index: 4; pointer-events: all" : ""}
    >
      <span>Exclusive Offers</span>
    </div>
  {/if}
  <div
    class="container-top"
    class:bgBlack={component == "exclusive"}
    style={`transform: translate3d(0,-${scrolling}px,0); opacity: ${opacity}`}
  >
    <span class="date-span">{today?.toLocaleString("en-GB", { month: "long" })}</span>
    <br />
    <p>Exclusive Offers</p>
  </div>
  <div class="sales-overflow" style={`transform: translate3d(0,-${gridScroll}px,0);`}>
    <div class="container-grid" on:scroll={scrollEvent} bind:this={scrollElement}>
      {#if validPromos}
        {#each validPromos as item}
          {#if dayOfPublish <= today && item.name.includes("Buy 2 Get 1 Free")}
            <a href={item.link} class="item" on:click={() => openSales(false, item.name)}>
              <img
                src={item?.image?.img}
                srcset={`${item?.image?.img} 1x, ${item?.image?.img2x} 2x`}
                loading="lazy"
                alt={item?.name}
              />
            </a>
          {:else if !item?.name.includes("Buy 2 Get 1 Free")}
            <a href={item?.link} class="item" on:click={() => openSales(false, item?.name)}>
              <img
                src={item?.image?.img}
                srcset={`${item?.image?.img} 1x, ${item?.image?.img2x} 2x`}
                loading="lazy"
                alt={item.name}
              />
            </a>
          {/if}
        {/each}
      {/if}
    </div>
  </div>
</dialog>

<style>
  .exclusive-offers {
    position: fixed;
    width: 196px;
    height: 63px;
    background-color: var(--collection);
    border-radius: 32px;
    z-index: 99;
    bottom: 60px;
    right: 40px;
    border: none;
    padding: 5px;
    cursor: pointer;
    display: grid;
    grid-template-columns: 20% 70%;
    padding: 0 20px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    color: #fdfdfd;
    font-family: "gotham-medium";
    box-shadow: 0 0 7px var(--collection);
    transition: all 0.5s ease;
    text-align: left;
    gap: 13px;
    font-size: 1rem;
    letter-spacing: 1.2px;
    font-weight: 500;
    line-height: 1.2;
    animation: startexclusive 500ms ease forwards;
    overflow: hidden;
  }
  .exclusive-offers.active {
    border-radius: 50%;
    width: 63px;
    height: 63px;
    padding: 20px;
    box-shadow: 0 0 7px var(--collection);
    grid-template-columns: 1fr;
  }
  .active img {
    animation: rotate 1s ease forwards;
    width: 25px;
    height: 25px;
  }
  .exclusive-offers p,
  .exclusive-offers svg {
    animation: opacityText 1s ease forwards;
  }
  @keyframes startexclusive {
    0% {
      opacity: 0;
    }
    10%,
    30% {
      transform: translateX(5px) rotate(5deg);
    }
    20%,
    40% {
      transform: translateX(-5px) rotate(-5deg);
    }
    100% {
      opacity: 1;
      transform: translateX(0) rotate(0);
    }
  }
  @keyframes startflame {
    0% {
      opacity: 0;
    }
    10%,
    30% {
      transform: translateX(5px) rotate(10deg);
    }
    20%,
    40% {
      transform: translateX(-5px) rotate(-10deg);
    }
    100% {
      opacity: 1;
      transform: translateX(0) rotate(0);
    }
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes shake-left-right {
    0%,
    100% {
      transform: rotate(0deg);
      transform-origin: 50% 50%;
    }
    10% {
      transform: rotate(10deg);
    }
    20% {
      transform: rotate(-10deg);
    }
    30% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(-10deg);
    }
    100% {
      transform: rotate(10deg);
    }
  }
  .sales {
    width: 0;
    height: 0;
    opacity: 0;
    border-radius: 20px 20px 0px 30px;
    border-radius: 20px 20px 0px 30px;
    box-shadow: var(--shadow-box);
    position: fixed;
    top: inherit;
    left: inherit;
    bottom: 120px;
    right: 90px;
    background-color: #fdfdfd;
    z-index: 999999;
    transition:
      width 0.3s ease,
      height 0.3s ease,
      opacity 0.3s ease;
    overflow: hidden;
    cursor: pointer;
  }
  .container-top {
    width: 100%;
    height: 180px;
    color: #fdfdfd;
    background-color: var(--collection);
    border-radius: 20px 20px 0 0;
    padding: 24px 0 20px 10%;
    position: relative;
    transition: all 0.5s ease;
    z-index: 2;
  }
  .top-after {
    height: 70px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    background-color: var(--collection);
    color: #fdfdfd;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    animation: opacity 500ms ease;
    pointer-events: none;
  }
  @keyframes opacityText {
    from {
      opacity: 0;
      display: none;
    }
    to {
      opacity: 1;
      display: initial;
    }
  }
  .bgBlack {
    background-color: var(--collection);
  }
  .container-top p {
    font-size: 1.875rem;
    font-weight: 600;
    font-family: "gotham-bold";
    line-height: 1.5;
    animation: opacityText 1s ease forwards;
  }
  .container-top span {
    font-family: "gotham-light";
    font-size: 1.25rem;
    animation: opacityText 1s ease forwards;
  }
  .sales button img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .open {
    width: 350px;
    height: 70svh;
    overflow: hidden;
    opacity: 1;
  }
  .sales-overflow {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    transform: translateY(-80px);
    z-index: 3;
    transition: all 0.3s ease;
    position: relative;
  }
  .sales .container-grid {
    opacity: 0;
  }
  .open .sales-overflow .container-grid {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    overflow-y: scroll;
    height: 100%;
    scrollbar-width: none;
    opacity: 1;
    transition: all 0.3s ease;
    padding-bottom: 60px;
    width: 95%;
    margin: 0 auto;
    position: relative;
  }
  .item {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1;
    border-radius: 15px;
    transition: all;
  }
  .item img {
    border-radius: 15px;
    box-shadow: var(--shadow-box);
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .item:nth-child(1),
  .item:nth-child(2) {
    grid-row: span 2;
    aspect-ratio: 1/1;
  }
  .item:nth-child(3) {
    grid-column: 1/-1;
  }
  dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.01);
  }
  @media (max-width: 767px) {
    .exclusive-offers {
      display: none;
    }
  }
</style>
